angular.module("licensure.internal").directive("internalEducationHeader", [
    function() {
        return {
            restrict: "E",
            templateUrl:
                paths.app + "components/headers/education-header/education-header.html",
            controller: [
                "$scope",
                "Permissions",
                function ($scope, Permissions) {

                    $scope.getPermission = function(state, variable) {
                        Permissions.view(state).then(function(access) {
                            $scope[variable] = access;
                        });
                    };
                }
            ],
            replace: true,
            link: function(scope, elem, attrs, ctrl) {}
        };
    }
]);
